import { secondsToTimelineTime } from '~/Util'
import { TRANSITIONS } from '~/enums'

export const getDefaultTransitionDurationDataObj = () => Object
  .keys(TRANSITIONS)
  .reduce((result, key) => ({
    ...result,
    [TRANSITIONS[key]]: secondsToTimelineTime(3),
  }), {})
